export const css = {
    oneaction: '_1xyBqdYV',
    ' _key': 'afcpe-theme/afcpe/quiz-widgets/prometric'
};
export default css;
